import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', () => {
  const searchContent = ref('');

  function setContent(val: string) {
    searchContent.value = val;
  }

  function getContent() {
    return searchContent.value;
  }

  return { setContent, getContent }
})